import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'

// import { cloneDeep } from 'lodash'
import SwitchPortal from '@/components/edit/SwitchPortal/index.vue'
import String from '@/components/edit/String/index.vue'

import Control from '@/helpers/control'

import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faTrashAlt)

interface Item {
	label: string
}

@Component({
	components: {
		SwitchPortal,
		String,
	},
})
export default class FieldMoneyPortal extends Vue {
	@Prop({ default: null }) readonly model!: number
	@Prop() name!: string
	@Prop() status!: string

	money = {
		decimal: ',',
		thousands: '.',
		precision: 2,
		masked: false,
		prefix: 'R$ ',
	}

	updatableModel: number | null = null
	created() {
		this.updatableModel = this.model
	}

	onInput() {
		this.processChange()
	}

	onUpdate() {
		this.$emit('input', this.name, this.updatableModel)
	}

	processChange = debounce(() => {
		this.onUpdate()
	}, 500)
}

function debounce(func, timeout = 1) {
	let timer
	return (...args) => {
		clearTimeout(timer)
		timer = setTimeout(() => {
			// @ts-ignore
			func.apply(this, args)
		}, timeout)
	}
}
